import { defineStyle as e, defineStyleConfig as a } from "@chakra-ui/react";
const l = e((r) => {
  const o = {
    bg: "red.500",
    _hover: { bg: "red.600" },
    _active: { bg: "red.700" }
  }, t = {
    bg: "teal.500",
    _hover: { bg: "teal.600" },
    _active: { bg: "teal.700" }
  };
  return {
    color: "white",
    borderColor: "transparent",
    ...r.colorScheme === "red" ? o : t
  };
}), d = e((r) => {
  const o = {
    color: "red.500",
    _hover: {
      color: "red.600",
      bg: "gray.100"
    },
    _active: {
      color: "red.700",
      bg: "gray.200"
    }
  }, t = {
    color: "teal.500",
    bg: "transparent",
    _hover: {
      color: "teal.600",
      bg: "teal.50"
    },
    _active: {
      color: "teal.700",
      bg: "teal.200"
    }
  };
  return {
    borderColor: "transparent",
    ...r.colorScheme === "red" ? o : t
  };
}), n = e((r) => {
  const o = {
    color: "red.500",
    borderColor: "gray.200",
    _hover: {
      color: "red.600",
      bg: "gray.100"
    },
    _active: {
      color: "red.700",
      bg: "gray.200"
    }
  }, t = {
    color: "teal.500",
    borderColor: "teal.200",
    _hover: {
      color: "teal.600",
      bg: "teal.50",
      borderColor: "teal.300"
    },
    _active: {
      color: "teal.700",
      bg: "teal.200",
      borderColor: "teal.400"
    }
  };
  return {
    bg: "white",
    ...r.colorScheme === "red" ? o : t,
    ".chakra-button__group[data-attached] > &:not(:last-of-type)": {
      marginEnd: "-1px"
    }
  };
}), c = e((r) => {
  const o = {
    color: "red.500",
    borderColor: "red.500",
    _hover: {
      color: "red.600",
      borderColor: "red.600",
      bg: "red.50"
    },
    _active: {
      color: "red.700",
      borderColor: "red.700",
      bg: "red.100"
    }
  }, t = {
    color: "teal.500",
    borderColor: "teal.500",
    _hover: {
      color: "teal.600",
      borderColor: "teal.600",
      bg: "teal.50"
    },
    _active: {
      color: "teal.700",
      borderColor: "teal.700",
      bg: "teal.200"
    }
  };
  return {
    bg: "white",
    ...r.colorScheme === "red" ? o : t,
    ".chakra-button__group[data-attached] > &:not(:last-of-type)": {
      marginEnd: "-1px"
    }
  };
}), i = {
  tertiary: n,
  secondary: c,
  primary: l,
  ghost: d
}, s = {
  lg: e({
    textStyle: "subheading2",
    minH: { base: 10, md: 12 },
    minW: { base: 10, md: 12 },
    px: 6
  }),
  md: e({
    textStyle: "bodyBold",
    minH: { base: 8, md: 10 },
    minW: { base: 8, md: 10 },
    px: 4
  }),
  sm: e({
    textStyle: "bodyBoldSmall",
    minH: { base: 7, md: 8 },
    minW: { base: 7, md: 8 },
    px: 3
  }),
  xs: e({
    textStyle: "bodyBoldSmall",
    minH: { base: 6, md: 6 },
    minW: { base: 6, md: 6 }
  })
}, b = {
  borderRadius: "lg",
  transitionProperty: "common",
  transitionDuration: "normal",
  border: "1px solid green",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.5,
    pointerEvents: "none",
    cursor: "not-allowed"
  }
}, m = a({
  baseStyle: b,
  variants: i,
  sizes: s,
  defaultProps: {
    variant: "primary",
    size: "md"
  }
});
export {
  m as buttonTheme,
  m as default
};
